/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, bool, arrayOf,
    shape, string, number,
} from 'prop-types';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

import Card from '@material-ui/core/Card';

import Address from '../RecipientDetails/Address';
import Recommendation from '../RecipientDetails/Recommendation';
import ProductAddedToCart from '../RecipientDetails/ProductAddedToCart';
import ShopTheSite from '../RecipientDetails/ShopTheSite';
import AnimatedCheck from '../../../../assets/svg/AnimatedCheck';
import { isEmpty } from '../../../../utils/object';
import configENV from '../../../../config';

const { PERSIST_KEY } = configENV;

class RecipientDetails extends Component {
    header = (addToCart, recipient) => (
        <>
            <div className="display-flex">
                {addToCart ? (
                    <AnimatedCheck className="success-color margin-right-half margin-bottom" />
                ) : (
                    ''
                )}
                <h2 className="margin-bottom-2x">
                    {recipient.firstname} {recipient.lastname}
                </h2>
            </div>
        </>
    );

    arrivedDate = (recipient) => {
        if (!isEmpty(recipient.cartDetail || recipient.previousItemMetadata || recipient.holidayCode || recipient.holidayDesc)) return null;

        const productName = ReactHtmlParser(recipient.previousItemMetadata?.description || '');
        const productNumber = recipient.previousItemMetadata?.partNumber || '';
        const previousYearDesc = recipient?.holidayCode ? recipient?.holidayDesc : recipient.giftArrived;
        const currentPartNumber = recipient?.currentItempartNumber || '';

        if ((productName && productName.length) || productNumber) {
            if (recipient.giftArrived) {
                return (
                    <div className="deliveryInfo margin-bottom-2x">
                        <div>Previously, you sent <span className="productSent">{productName} ({productNumber})</span> for arrival on <span className="productSent">{previousYearDesc}</span>.</div>
                        <div>{
                            currentPartNumber === productNumber
                                ? 'You can send this item again or choose a gift from our recommendations.'
                                : 'Currently this product not available. Choose closest match or choose a gift from our recommendations below.'
                        }
                        </div>
                    </div>
                );
            }
            // Currently show for TPF or CCO when doesnt have the delivery date
            return (
                <div className="deliveryInfo margin-bottom-2x">
                    <div>
                        Previously, you sent <span className="productSent">{productName} ({productNumber})</span>.
                        <span>{
                            currentPartNumber === productNumber
                                ? ' You can send this item again or choose a gift from our recommendations.'
                                : ' Currently this product not available. Choose closest match or choose a gift from our recommendations below.'
                        }
                        </span>
                    </div>
                </div>
            );
        }
        return (
            <div className="deliveryInfo padding-bottom-2x margin-bottom-2x">
                You can now choose a gift from our recommendations below or find something different using Enter Item Number or Shop the Site.
            </div>
        );
    };

    renderLayout = (isInsideModal, addToCart, recipient) => (
        <>
            <div
                className={
                    isInsideModal === 'true'
                        ? 'modal-content has-footer-content'
                        : 'padding'
                }
            >
                {isInsideModal === 'true'
                    ? ''
                    : this.header(addToCart, recipient)}
                <Address recipient={recipient} />
                {this.arrivedDate(recipient)}
                <Recommendation recipient={recipient} />
                <ProductAddedToCart recipient={recipient} />
            </div>
            <ShopTheSite
                customClass={
                    isInsideModal === 'true' ? '' : 'padding no-margin'
                }
                customButtonClass={
                    isInsideModal === 'true'
                        ? 'buttonHDWhite'
                        : 'buttonHDSecondary'
                }
                recipient={recipient}
                addToCart={addToCart}
            />
        </>
    );

    render() {
        // eslint-disable-next-line object-curly-newline
        const { isInsideModal, content, recipient } = this.props;
        const cardContent = !isEmpty(content) && isInsideModal === 'true' ? content : recipient;
        const { addToCart } = cardContent;
        // console.log('RecipientDetails - cardContent', cardContent);
        if (isEmpty(cardContent)) {
            return null;
        }
        return (
            <>
                {isInsideModal === 'true' ? (
                    <>
                        {this.renderLayout(
                            isInsideModal,
                            addToCart,
                            cardContent,
                        )}
                    </>
                ) : (
                    <Card
                        key={cardContent.id}
                        className="max-width-100 margin-bottom-2x"
                    >
                        {this.renderLayout(
                            isInsideModal,
                            addToCart,
                            cardContent,
                        )}
                    </Card>
                )}
            </>
        );
    }
}

RecipientDetails.defaultProps = {
    recipient: {},
    content: {},
    isInsideModal: '',
};

RecipientDetails.propTypes = {
    isInsideModal: string,
    content: object,
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        NamePrefix: string,
        FirstName: string,
        MiddleInitial: string,
        LastName: string,
        NameSuffix: string,
        RelationShip: string,
        NickName: string,
        EmailAddress: string,
        LastUpdateDate: string,
        PhoneNumber: string,
        AlternatePhoneNumber: string,
        Fax: string,
        EmployerName: string,
        NumberOfAddresses: number,
        DateOfBirth: string,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                IsPartialMatch: bool,
                IsUnknownAddress: bool,
                Latitude_degrees: number,
                Longitude_degrees: number,
                IsBillingAddress: bool,
                ContactId: number,
            }),
        ),
    }),
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    // console.log('RecipientDetails - newState', newState);
    return {
        content: newState.modal.content, // use this to update the component
        toggleState: newState.toggleState,
    };
};

export default connect(mapStateToProps)(RecipientDetails);
